import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import CustomerGraph from "../../features/dashboard/customerGraph";
import IssuesGraph from "../../features/dashboard/issuesGraph";
import MaintenanceTeamGraph from "../../features/dashboard/maintenanceTeamGraph";
import EarningGraph from "../../features/dashboard/earningGraph";
import usePermission from "../../hooks/usePermission";
import {
  useLazyChangeGraphStatusQuery,
  useLazyGetDashboardQuery,
} from "../../services/dashboard";
import { GRAPH_TYPE, GRAPH_TYPE_DAILY } from "../../utils/enums";

const Dashboard = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [totalEarningGraph, setTotalEarningGraph] = useState();

  const [totalIssueGraph, setTotalIssueGraph] = useState();
  const [totalSpGraph, setTotalSpGraph] = useState();
  const [totalUserGraph, setTotalUserGraph] = useState();
  const [dashboardData, setDashboardData] = useState<any | null>(null);
  const [customerType, setCustomerType] = useState<string>(
    GRAPH_TYPE_DAILY.WEEKLY
  );

  const [graphFor, setGraphFor] = useState<number | null | undefined>(null);
  const [teamType, setTeamType] = useState<string>(GRAPH_TYPE_DAILY.WEEKLY);
  const [issueType, setIssueType] = useState<string>(GRAPH_TYPE_DAILY.WEEKLY);

  const [earningType, setEarninType] = useState<string>(
    GRAPH_TYPE_DAILY.WEEKLY
  );

  usePermission({ label: "Dashboard", page_permission: "isView" });

  const [dashboardDataMethod] = useLazyGetDashboardQuery();
  const [changeStatus] = useLazyChangeGraphStatusQuery();

  const getDashboardData = async () => {
    setIsLoading(true);
    try {
      const response = await dashboardDataMethod().unwrap();
      if (response?.statusCode === 200) {
        setDashboardData(response?.data);
        setTotalEarningGraph(response?.data?.totalEarningAdminGraph);
        setTotalIssueGraph(response?.data?.totalIssueGraph);
        setTotalSpGraph(response?.data?.totalSpGraph);
        setTotalUserGraph(response?.data?.totalUserGraph);
      }
    } catch (error: any) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeStatus = async (graphFor: number, type: string) => {
    setIsLoading(true);
    try {
      const response = await changeStatus({
        graphFor,
        type,
      }).unwrap();
      if (response?.statusCode === 200) {
        if (graphFor === GRAPH_TYPE.USER_GRAPH) {
          setTotalUserGraph(response?.data);
        } else if (graphFor === GRAPH_TYPE.ISSUE_GRAPH) {
          setTotalIssueGraph(response?.data);
        } else if (graphFor === GRAPH_TYPE.SP_GRAPH) {
          setTotalSpGraph(response?.data);
        } else if (graphFor === GRAPH_TYPE.EARNING_GRAPH) {
          setTotalEarningGraph(response?.data);
        }
      }
    } catch (error: any) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (graphFor) {
      handleChangeStatus(graphFor, earningType);
    }
  }, [earningType]);

  useEffect(() => {
    if (graphFor) {
      handleChangeStatus(graphFor, teamType);
    }
  }, [teamType]);

  useEffect(() => {
    if (graphFor) {
      handleChangeStatus(graphFor, issueType);
    }
  }, [issueType]);

  useEffect(() => {
    if (graphFor) {
      handleChangeStatus(graphFor, customerType);
    }
  }, [customerType]);

  useEffect(() => {
    getDashboardData();
  }, []);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Dashboard</h1>
      </div>
      <div className="stats_boxes gap_m">
        <div className="cards" onClick={() => navigate("/manage-customers")}>
          <figure>
            <img src="/static/images/user_icon.svg" alt="" />
          </figure>
          <h2>{dashboardData?.totalCustomers || "0"}</h2>
          <p>Total Property Owners</p>
        </div>

        <div className="cards" onClick={() => navigate("/manage-issues")}>
          <figure>
            <img src="/static/images/support_icon.svg" alt="" />
          </figure>
          <h2>{dashboardData?.totalIssues || "0"}</h2>
          <p>Total Issues</p>
        </div>

        <div
          className="cards"
          onClick={() => navigate("/manage-maintenance-team")}
        >
          <figure>
            <img src="/static/images/people_icon.svg" alt="" />
          </figure>
          <h2>{dashboardData?.totalTeams || "0"}</h2>
          <p>Total Maintenance Team</p>
        </div>
        <div className="cards" onClick={() => navigate("/manage-payments")}>
          <figure>
            <img src="/static/images/money_icon.svg" alt="" />
          </figure>
          <h2>AED {dashboardData?.totalEarning || "0"}</h2>
          <p>Total Earning</p>
        </div>
      </div>
      <div className="grid_sc gap_m">
        <CustomerGraph
          data={totalUserGraph}
          setCustomerType={setCustomerType}
          customerType={customerType}
          setGraphFor={setGraphFor}
        />
        <IssuesGraph
          data={totalIssueGraph}
          setIssueType={setIssueType}
          issueType={issueType}
          setGraphFor={setGraphFor}
        />
        <MaintenanceTeamGraph
          data={totalSpGraph}
          setIssueType={setTeamType}
          issueType={teamType}
          setGraphFor={setGraphFor}
        />
        <EarningGraph
          data={totalEarningGraph}
          setIssueType={setEarninType}
          issueType={earningType}
          setGraphFor={setGraphFor}
        />
      </div>
    </MainContainer>
  );
};

export default Dashboard;
